import { useState } from "react";
import { Box, Tabs, Tab } from "@mui/material";
import { BasicCalculatorForm } from "./BasicCalculatorForm";
import { BasicCalculatorResponse } from "./BasicCalculatorResult";
import { CommercialCalculator } from "./commercial/CommercialCalculator";
import { ResidentialCalculator } from "./residential/ResidentialCalculator";
import { Summary } from "./residential/Summary";
import { useDispatch, useSelector } from "react-redux";
import { LoaderComponent } from "../Loader";
import { updateCalculatorTab } from "../../redux/features/calculatorSlice";
import { ResidentialQuoteSummary } from "../jobs2/ResidentialQuoteSummary";

export const CalculatorTabs = () => {
  const state = useSelector((state) => state.basicCalculatorState);
  const [calculatorLoading, setCalculatorLoading] = useState(false);
  const [residentialCalculatorTab, setResidentialCalculatorTab] = useState(0);
  const [residentialQuote, setResidentialQuote] = useState();
  const [commercialCalculatorTab, setCommercialCalculatorTab] = useState(0);
  const [commercialQuote, setCommercialQuote] = useState();

  const { tab } = useSelector((state) => state.calculatorState);
  const dispath = useDispatch();

  const handleResidentialTab = (tab) => {
    setResidentialCalculatorTab(tab);
  };

  const handleResidentialQuote = (quote) => {
    setResidentialQuote(quote);
  };

  return (
    <Box sx={{ width: "100%", height: "100%", display: "flex", flexDirection: "column" }}>
      <Tabs value={tab} onChange={(e, val) => dispath(updateCalculatorTab(val))} variant="fullWidth" sx={{ mb: 2 }}>
        <Tab label="Calculator" />
        <Tab label="Commercial Calculator" />
        <Tab label="Residential Calculator" />
      </Tabs>

      {tab === 0 && (
        <Box sx={{ flex: 1, overflow: "auto", justifyContent: "center" }}>
          {state.state === 0 && <BasicCalculatorForm setLoading={setCalculatorLoading} />}
          {state.state === 1 && !calculatorLoading && <BasicCalculatorResponse />}
          <LoaderComponent open={calculatorLoading} type="spinner" />
        </Box>
      )}

      {tab === 1 && (
        <Box sx={{ flex: 1, overflow: "auto" }}>
          {commercialCalculatorTab === 0 && <CommercialCalculator handleCommercialQuote={setCommercialQuote} handleCommercialTab={setCommercialCalculatorTab} />}
          {commercialCalculatorTab === 1 && <Summary quote={commercialQuote} handleResidentialTab={setCommercialCalculatorTab} type="commercial" />}
        </Box>
      )}

      {tab === 2 && (
        <Box sx={{ flex: 1, overflow: "auto" }}>
          {residentialCalculatorTab === 0 && <ResidentialCalculator handleResidentialQuote={handleResidentialQuote} handleResidentialTab={handleResidentialTab} />}
          {residentialCalculatorTab === 1 && <ResidentialQuoteSummary calculator={true} quote={residentialQuote} handleResidentialTab={handleResidentialTab} />}
        </Box>
      )}
    </Box>
  );
};
